<template>
  <div class="contact">
    <div v-if="saasApiContact" class="contact__btn contact__btn-customer" @click="handleCustomerClick({ templateId: '6651711' })">
      <div>
        <img :src="require('@/assets/images/icon-headphone-white.svg')" />
      </div>
      <div>在线客服</div>
    </div>
    <div v-else-if="qrCodeUrl" class="contact__btn contact__btn-customer">
      <div>
        <img :src="require('@/assets/images/icon-headphone-white.svg')" />
      </div>
      <div>在线咨询</div>
      <div class="img-wrap" v-if="qrCodeUrl">
        <img class="qr-code-img" :src="qrCodeUrl" alt="" />
        <span>添加微信好友，在线咨询</span>
      </div>
    </div>
    <div
      v-else
      class="contact__btn contact__btn-customer"
      @click="handleCustomerServiceClick({ entry: source, newCustomerServiceLink: newCustomerServiceLink })"
    >
      <div>
        <img :src="require('@/assets/images/icon-headphone-white.svg')" />
      </div>
      <div>在线客服</div>
    </div>

    <div class="contact__btn-phone">
      <a class="contact__btn" href="tel:0571-85785223" @click="handlePhoneClick">
        <div>
          <img :src="require('@/assets/images/icon-phone-white.svg')" />
        </div>
        <div>销售热线</div>
      </a>
      <div class="phone-number">0571-85785223</div>
    </div>
    <div class="contact__btn-phone">
      <a class="contact__btn" href="tel:400-0878-198" @click="handlePhoneClick">
        <div>
          <img :src="require('@/assets/images/icon-phone-white.svg')" />
        </div>
        <div>售后服务</div>
      </a>
      <div class="phone-number">400-0878-198</div>
    </div>

    <BackToTop />
  </div>
</template>

<script>
import qiyuMixin from '@/mixins/form/qiyu.js'

export default {
  mixins: [qiyuMixin],
  components: {
    BackToTop: () => import('./BackToTop.vue'),
  },
  mounted() {
    this.addQiyuScript()
  },
  props: {
    landingPageName: {
      type: String,
      default: '',
    },
    source: {
      type: String,
      default: '',
    },
    newCustomerServiceLink: {
      type: String,
      default: '',
    },
    saasApiContact: {
      // 20230406新增saas和api落地页，需要请求新的客服地址
      type: Boolean,
      default: false,
    },
    qrCodeUrl: {
      // 使用带有卫瓴二维码的弹框
      type: String,
      default: '',
    },
  },
  methods: {
    handlePhoneClick() {
      // TODO:
      if (this.landingPageName === 'esignPropagate') {
        window.meteor && window.meteor.track && window.meteor.track('phone', { convert_id: '1655142884209676' })
      }
      this.$tsignData.track('sign_olandingpage_phonecallconsult')
      this.$tsignData.track('click_phone_call')
    },
  },
}
</script>

<style lang="less" scoped>
.contact /deep/ .back-to-top {
  position: relative;
  bottom: 0;
  right: 0;
  overflow: hidden;
  display: inline-block;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
}
.contact {
  display: block;
  position: fixed;
  bottom: 50%;
  right: 0;
  transform: translateY(50%);
  z-index: 9990;
  width: 80px;
  text-align: right;

  &__btn {
    flex-shrink: 0;
    display: inline-block;
    width: 60px;
    height: 40px;
    background-color: #e61717;
    color: #fff;
    font-size: 12px;
    padding: 10px 0;
    text-align: center;
    margin-bottom: 1px;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    box-sizing: content-box;

    &-customer {
      padding-right: 0;
      transition: padding 200ms;

      &:hover {
        padding-right: 20px;
      }
    }
    img {
      height: 26px;
      width: 26px;
      margin: 0 auto;
    }
  }

  &__btn-phone {
    display: flex;
    width: 400px;
    margin-left: 20px;
    transition: margin 200ms;

    .phone-number {
      font-size: 20px;
      line-height: 60px;
      height: 60px;
      color: #fff;
      background-color: #e61717;
      padding-right: 10px;
    }

    &:hover {
      margin-left: -140px;
    }
  }
  .img-wrap {
    position: absolute;
    width: 170px;
    height: 200px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(210, 214, 221, 0.5);
    border-radius: 6px;
    border: 1px solid #dee1e8;
    padding: 6px;
    right: 86px;
    top: 0px;
    .qr-code-img {
      width: 158px;
      height: 158px;
      margin-bottom: 6px;
    }
    span {
      color: #333;
      font-size: 12px;
    }
  }
  .contact__btn {
    z-index: 9;
  }
  .phone-number {
    z-index: 9;
  }
}
</style>
